import React from "react";

interface TruncatedTextProps {
    text: string;
    maxWidth?: number | string;
    className?: string;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
    text,
    maxWidth,
    className = ""
}) => {
    return (
        <div
            className={`truncate ${className}`}
            style={{
                maxWidth: maxWidth ? (typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth) : '100%'
            }}
            title={text}
        >
            {text}
        </div>
    );
};